import { httpRequest } from '@/api/httpClient'

export const authApi = {
  login(username, password) {
    return httpRequest('/api/auth/login', {
      method: 'POST',
      body: { username, password },
      skipAuth: true,
      retry: false
    })
  },

  refresh() {
    return httpRequest('/api/auth/refresh', {
      method: 'POST',
      skipAuth: true,
      retry: false
    })
  },

  logout() {
    return httpRequest('/api/auth/logout', {
      method: 'POST',
      skipAuth: true,
      retry: false,
      responseType: 'raw'
    })
  },

  sendSmsCode(phone) {
    return httpRequest('/api/auth/sms/send-code', {
      method: 'POST',
      body: { phone },
      skipAuth: true,
      retry: false
    })
  },

  smsLogin(phone, code) {
    return httpRequest('/api/auth/sms/login', {
      method: 'POST',
      body: { phone, code },
      skipAuth: true,
      retry: false
    })
  },

  me() {
    return httpRequest('/api/auth/me', {
      method: 'GET'
    })
  }
}
